import { useSelectSurgeryOptions } from "@/features/events/features/surgeries/api/selectSurgeryOptions";
import { useSelectForms } from "@/features/forms/api/selectForms";
import { useInjectionMethodsQuery } from "@/features/injection/api/selectInjectionMethods";
import { useSelectOrganisations } from "@/features/organisations/api/selectOrganisations";
import { useSelectStaff } from "@/features/profile/api/selectStaff";
import { useSchedulesQuery } from "@/features/schedules/api/selectSchedules";
import DiarySummaryForm from "@/features/templates/components/DiarySummaryForm";
import { createFileRoute } from "@tanstack/react-router";
import useOrganisationOptions from "../../../../../components/hooks/useOrganisationOptions";
import useUsersOrganisationsRolesQuery from "../../../../../features/auth/api/selectUsersOrganisationsRoles";

export const Route = createFileRoute("/_app/new/diary/invite/diary")({
  component: DiarySummaryFormRoute,
});

function DiarySummaryFormRoute() {
  const search = Route.useSearch();

  const { auth } = Route.useRouteContext();
  const { data: organisations } = useUsersOrganisationsRolesQuery(auth.id);

  const { data: staff = [] } = useSelectStaff();
  const { data: forms = [] } = useSelectForms();
  const { data: schedules = [] } = useSchedulesQuery();
  const { data: injectionMethods = [] } = useInjectionMethodsQuery();
  const { data: surgeryOptions = [] } = useSelectSurgeryOptions();

  return (
    <DiarySummaryForm
      search={search}
      organisations={organisations}
      staff={staff}
      forms={forms}
      schedules={schedules}
      injectionMethods={injectionMethods}
      surgeryOptions={surgeryOptions}
    />
  );
}
